import { Box, styled } from '@mui/material';

export const PreviewContainer = styled(Box)(({ theme }) => ({
  border: '1px solid',
  borderColor: theme.palette.divider,
  borderRadius: '12px',
  overflow: 'hidden',
  backgroundColor: theme.palette.background.default,
}));
